/* eslint-disable */
import * as Comlink from 'comlink';
import AbstractWebSocket from '@/utils/abstractWebSocket';
import {
  BroadcastChannel,
  createLeaderElection
} from 'broadcast-channel';
import websocket from './ws.worker.js';
import { isWebView } from '../index.js';

const version = window.buildTimestamp;
const channelName = `ligai-ws-${version}`;

let worker = null;
let workerType = '';
let instanceId = + new Date();
try {
  if (window.SharedWorker && !isWebView()){
    worker = Comlink.wrap((new SharedWorker('./ws.worker.js', { type: 'module', name: 'wsSharedWorker' }).port));
    workerType = 'SharedWorker';
  } else if (window.Worker){
    worker = Comlink.wrap(new Worker('./ws.worker.js', { type: 'module', name: 'wsWorker' }));
    workerType = 'Worker';
  } else {
    worker = websocket;
  }
} catch(e) {
  window.console.log('SharedWorker create failed:', e);
  window.console.log('error message:', e.message);
}

// 系统通知类事件
const notifyEvents = ['issueAddNotice', 'issueUpdateNotice', 'issueDeleteNotice'];
class WsWorker extends AbstractWebSocket {
  isLeader = false
  globalEvent = {}
  async init(){
    this.handleMsg = this.handleMsg.bind(this);
    this.initChannel();
    this.initLeader();
  }
  handleMsg(msgData){
    const { eventName, result, data, workerInstanceId, type } = msgData;
    if (eventName === 'leaderChange') {
      this.isLeader = false;
      return;
    }
    console.log('接受到消息', msgData, this.isLeader);
    // 当为webworker时，会存在多个worker实例
    if (workerType === 'Worker' && instanceId !== workerInstanceId) {
      return;
    }
    // 系统提示消息只触发一次
    if (notifyEvents.includes(eventName) && !this.isLeader) {
      return;
    }

    // global事件推送处理
    if (type === 'global') {
      this.globalEvent[eventName].forEach((fn) => {
        if (typeof fn === 'function') {
          fn(data);
          return;
        }
        this.fire(eventName, data);
      })
      return;
    }
    this.fire(eventName, result, data);
  }
  async initLeader(){
    const elector = createLeaderElection(this.channel);
    elector.awaitLeadership().then(
      async () => {
        this.isLeader = true;
        this.channel?.postMessage({eventName: 'leaderChange'});
      }
    );
  }
  initChannel(){
    this.channel = new BroadcastChannel(channelName, {
      // type: 'localstorage',
      webWorkerSupport: true
    });
    this.channel.addEventListener('message', this.handleMsg);
  }
  destory(){
    this.channel.removeEventListener('message', this.handleMsg);
  }
  connect(url, opt){
    console.info(`ws ${url}${channelName} 连接成功`, Date.now());
    const {userId} = opt;
    this.init();
    worker.init({userId, url, opt, instanceId, channelName});
  }
  on(event, fn) {
    const [ type ] = event.split(':');
    if (type === 'global') {
      const mark = `${event}-${+new Date()}-${Math.random()}`
      fn.mark = mark;
      // this.globalEvent[mark] = fn;
      if (!this.globalEvent[event]) {
        this.globalEvent[event] = [];
      }
      this.globalEvent[event].push(fn);
      worker.on(event, mark);
    }
    return super.on(event, fn);
  }
  off(event, fn) {
    const [ type ] = event.split(':');
    if (type === 'global') {
      // Reflect.deleteProperty(this.globalEvent, fn.mark);
      if (this.globalEvent[event]) {
        this.globalEvent[event] = this.globalEvent[event].filter(i => i !== fn);
      }
      worker.off(event, fn.mark);
    }
    return super.off(event, fn);
  }
  emit(event, data) {
    worker.emit(event, data);
  }
}

const instance = new WsWorker();
// instance.init();
export default instance;
